import React, { useEffect, useState } from "react";
import { observer } from 'mobx-react-lite';
import { Button } from 'antd';
import cx from 'classnames';
import cs from './index.module.less';
import { Context,Hooks,Util,Request } from "@xt/xtbase";
import PrePagination from "assets/images/home/PrePagination.png";
import PrePaginationDis from "assets/images/home/PrePaginationDis.png";
import NextPagination from "assets/images/home/NextPagination.png";
import NextPaginationDis from "assets/images/home/NextPaginationDis.png";

const {useTranslation, useDocumentWidth} = Hooks;

const ScrollPagination = ({
  position = 'right',
  hasPrev,
  hasNext,
  onPrev,
  onNext,
  isActivePage,
  loading = false,
  ...restProps
}) => {

  const prevHandleClick = () => {
    if(!isActivePage) return
    if (hasPrev && onPrev) {
      onPrev();
      setCurrent(current - 1)
    }
  };

  const nextHandleClick = () => {
    if(!isActivePage) return
    if (hasNext && onNext) {
      onNext();
      setCurrent(current + 1)
    }
  };

  const t = useTranslation();

  const positionClass = position === 'right' ? cs.right : position === 'center' ? cs.center : cs.left;

  const [current, setCurrent] = useState(1)

  return (
    <div className={cx(cs.container, positionClass)} {...restProps}>
      {/* <Button size="small" className={cs.btn} disabled={!hasPrev} onClick={prevHandleClick}>
        {t('console.board.prevPage')}
      </Button>
      <Button size="small" className={cs.btn} disabled={!hasNext} onClick={nextHandleClick}>
        {t('console.board.nextPage')}
      </Button> */}
      {hasPrev && !loading && <img src={PrePagination} onClick={prevHandleClick} className={cs.arrowPre} />}
      {(!hasPrev || loading) && <img src={PrePaginationDis} className={cs.arrowPreDis} />}
      <div className={cs.current}>{current}</div>
      {hasNext && !loading && <img src={NextPagination} onClick={nextHandleClick} className={cs.arrowNext} />}
      {(!hasNext || loading) && <img src={NextPaginationDis}  className={cs.arrowNextDis} />}
    </div>
  );
};

export default ScrollPagination;
